module.exports = __webpack_public_path__ + "img/IMG_9922.e1b4966b.jpg";